import {isEnglishOnly} from 'utils/Helper';
import * as yup from 'yup';

export const PERSONAL_INFO_SCHEMA = yup.object({
  faName: yup.string().defined(),
  faFamily: yup.string().defined(),
  enName: yup
    .string()
    .required('نام را به انگلیسی را وارد کنید')
    .test('is-english', 'فقط کلمات انگلیسی', (value) => Boolean(value && isEnglishOnly(value)))
    .max(155, 'نام به انگلیسی نمیتواند بیشتر از ۱۵۵ کاراکتر باشد')
    .min(3, 'نام به انگلیسی نمیتواند کمتر از ۳ کاراکتر باشد'),
  enFamily: yup
    .string()
    .required('نام خانوادگی به انگلیسی را وارد کنید')
    .test('is-english', 'فقط کلمات انگلیسی', (value) => Boolean(value && isEnglishOnly(value)))
    .max(155, 'نام خانوادگی به انگلیسی نمیتواند بیشتر از ۱۵۵ کاراکتر باشد')
    .min(3, 'نام خانوادگی به انگلیسی نمیتواند کمتر از ۳ کاراکتر باشد'),
  nationalCode: yup
    .string()
    .required('کد ملی را وارد کنید')
    .min(10, 'کد ملی باید ۱۰ رقم باشد')
    .max(10, 'کد ملی باید ۱۰ رقم باشد')
});
